<template>
  <Teleport to="body">
    <template v-if="pictureContainer === 'pazzo' || pictureContainer === 'pazzo-t'">
      <div
        v-for="(alert, index) in alerts"
        :key="index"
        class="pz-alert-modal-style"
        :data-name="alert.dataName"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              <i class="icon-pazzo" />
            </h4>
          </div>
          <div class="modal-body">
            <div class="modal-info" :class="{ 'pb-0': alert.type === 'special' }">
              <p v-html="alert.msg" />
            </div>
            <slot :alert="alert" :index="index" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(alert, index) in alerts"
        :key="index"
        class="alert-modal-style"
        :data-name="alert.dataName"
      >
        <div class="modal-body">
          <div class="modal-info" :class="{ 'pb-0': alert.type === 'special' }">
            <p v-html="alert.msg" />
          </div>
          <slot :alert="alert" :index="index" />
        </div>
      </div>
    </template>
  </Teleport>
</template>

<script setup>
import useAlert from '@global/composable/useAlert';

const { alerts } = useAlert();

const pictureContainer = window.PictureContainer;
</script>
